import React, {Fragment} from 'react';
import {Layout, NavLink, Switch, Route, Diary} from 'components';
import {useLocation, useNamedSelector} from 'helpers';
import {forbid} from 'store/session';

export function Router() {
  const permissions = useNamedSelector('permissions.list');
  const isOther = /mid-day-check-in|mood-meter/.test(useLocation().pathname);
  return (
    <Fragment>
      <Layout.Title>Journal</Layout.Title>
      <Layout.Topbar.Tabs>
        <NavLink exact={isOther} to="/diary/">Journal</NavLink>
        <NavLink exact to={permissions.canAdd.diary && '/diary/mid-day-check-in/'} onClick={permissions.canAdd.diary ? undefined : forbid}>Mid-day Check-in</NavLink>
        <NavLink exact to={permissions.canAdd.diary && '/diary/mood-meter/'} onClick={permissions.canAdd.diary ? undefined : forbid}>Mood Meter</NavLink>
      </Layout.Topbar.Tabs>
      <Route path="/diary/:date?/">
        <Diary.Sidebar />
      </Route>
      <main>
        <Switch>
          <Route path="/diary/mood-meter/" component={Diary.MiddayMoodMeter} />
          <Route path="/diary/mid-day-check-in/" component={Diary.MiddayCheckIn} />
          <Route path="/diary/add/" component={Diary.EditForm} />
          <Route path="/diary/:date/:id/">
            { ({ match: { params } }) => <Diary.EditForm {...params} /> }
          </Route>
          <Route path="/diary/" component={Diary.Home} />
        </Switch>
      </main>
    </Fragment>
  );
}
